import React from "react";

interface HorizontalLineProps {
    color?: string;
    height?: number;
}

export const HorizontalLine: React.FC<HorizontalLineProps> = ({
    color = "#e0e0e0",
    height = 1,
}) => {
    return (
        <hr
            style={{
                color: color,
                backgroundColor: color,
                height: height,
                border: "none",
            }}
        />
    );
};
